<script>
import Service from '../../services/vessel-protocol';
import CommonService from '../../services/common'

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import { useVuelidate } from "@vuelidate/core";
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import Checkbox from 'primevue/checkbox';

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'voyageNumber', 'isDisabled'],
  emits: ['updateDocuments'],

  components: {
    ResponsiveButton,
    Checkbox
},
  data(){
    return {
      data: [],
      dischargeTrackingRecord: null,
      dischargeTrackingRecordMap: {},
      newDocument: {},
      allOptions: {
        'Prospetti - Istanze': ['1-Prospetto di calcolo per la riliquidazione', '7-Istanza di revisione valore', 
          '10-Prospetto di 1^ revisione valore (Import)', '71-Prospetto di rettifica peso', '72-Rettifica peso e valore riproporzionato'], 
        'Comunicazioni per Dogana': ['11-Destinazione CEE senza INF 3', '12-Destinazione CEE con INF 3', '13-Destinazione extra CEE', '14-Rientro parziale CEE e saldo extra CEE',
          '19-Certificato discarica', '23-Valori in dogana', '24-Comunicazione in Dogana per la presentazione del F.O.'], 
        'Comunicazioni per Camera di Commercio': ['27-Richiesta del certificato di origine', '28-Annullamento del certificato di origine emesso',
          '29-Richiesta di rilascio del duplicato del certificato di origine'], 
        'Autorizzazioni': ['30-Presentazione a posteriori dell\'EUR 1', '31-Richiesta del rilascio a posteriori dell\'EUR 1', '32-Presentazione a posteriori dell\'ATR',
          '33-Richiesta del rilascio a posteriori dell\'ATR', '34-Presentazione a posteriori del FORM A'], 
        'Certificati': ['36-Certificato di origine', '37-EUR 1', '38-ATR', '39-XAB', '40-INF 3', '41-INF 4', '42-T2L', '43-T2LF', '44-Dichiarazione di origine',
          '45-Crude oil and mineral fuel declaration', '46-Confirmation Letter'], 
        'Lettere in Dogana': ['16-Richiesta INF 4', '17-Annullamento bolletta', '18-Duplicato documenti emessi', '20-Nazionalizzazione SLOP', '22-Origine SLOP',
          '47-Consegna originale EUR 1', '48-Consegna originale FORM A', '50-Invio INF 3 a cliente', '51-Servizi generali', '471-Consegna originale ATR'],
        'Lettere ai Committenti': ['51-Consegna bolletta export', '53-Trasmissione documenti amministrativi', '54-Consegna bolletta import SLOP'], 
        'Altro': ['99-Documenti esterni'], 
        'Tasse Portuali': ['Tasse Portuali'],
        'Bolletta Doganale - EAD - Doc. Liquidaz': ['100-Bolletta Telematica', '101-Bolletta Doganale con QTA Dichiarata', '102-Bolletta Doganale con QTA Accertata',
          '103-Bolletta Doganale di Revisione Valore', '104-EAD', '105-Doc. Comm.'], 
        'Visita Merce': [], 
        'Controllo Documentale': [],
        'Tracking Discariche': ['Dichiarazione di esportazione', 'Dichiarazione di non manipolazione', 'Certificato di origine', 'Voyage Report', 'Ricevuta documenti e campioni']
      },
      typeOptions: [],
      categoryOptions: [],
      emailDialogVisible: false,
      emailDialogVisible5253: false,
      selectedReport: "",
      dischargeTrackingStatusDialogVisible: false,
      currentStatus: null,
      genericStatuses: [
        {
          label: 'ToBeValidated',
          value: 'ToBeValidated'
        },
        {
          label: 'Valid',
          value: 'Valid'
        },
        {
          label: 'NotValid',
          value: 'NotValid'
        }
      ],
      dischargeTrackingDocumentSelected: null
    }
  },
  validations(){
    return {
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
    documentsSorted(){
      let sorted = [];
      if(this.data && this.data.length > 0){
        sorted = Array.from(this.data);
        sorted.sort((a, b) => {
          return new Date(b.documentDate) - new Date(a.documentDate);
        })
      }
      return sorted;
    }
  },
  created(){
    this.typeOptions = Object.keys(this.allOptions);
  },
  mounted(){
    this.loadDocuments();
    this.loadDischargeTrackingRecord();
  },
  watch: {

  },
  methods: {
    loadDischargeTrackingRecord(){
      Service.loadDischargeTrackingByProtocolId(this.vesselProtocolId, ({success, data, message}) => {
        if(success){
          this.dischargeTrackingRecord = data;
          this.createDischargeTrackingMap();
        }
      })
    },
    loadDocuments(){
      Service.getAttachmentsByIdVesselProtocol(this.vesselProtocolId, ({success, data, message}) => {
        if(success){
          this.data = data;
        } else{
          this.data = [];
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
        this.$emit('updateDocuments', this.data)
      })
    },
    openDocument(item){
      window.open(item);
    },
    downloadDocument({documentGuid, fileName, fileExtension}){
      this.$store.dispatch("generic/setLoading", true);
      let fileNameWithExtension = fileName + fileExtension;
      Service.downloadDocumentVesselProtocol({documentGuid: documentGuid, fileNameWithExtension }, ({success, data, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        
        if(success){
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileNameWithExtension);
          document.body.appendChild(fileLink);
      
          fileLink.click();
        } else{
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    openSendEmail(data){
      if(data.documentType == "53-Trasmissione documenti amministrativi"){
        this.lastLoaded = data.id;
        this.selectedReport = data.documentType;
        this.emailDialogVisible5253 = true;
      }else if(data.documentType == "52-Consegna bolletta export"){
        this.lastLoaded = data.id;
        this.selectedReport = data.documentType;
        this.emailDialogVisible5253 = true;
      }else{
        this.lastLoaded = data.documentGuid;
        this.emailDialogVisible = true;
      }
        this.showAddress(data.id);

    },
    sendEmail(_, id = false) {
      this.$store.dispatch("generic/setLoading", true);

      let idList = id ? [id] : this.data.filter((document) => document.check).map((item) => item.id);

      let body = {
        idList: idList,
        guiIdDocument : this.lastLoaded
      }
      Service.sendEmailVesselProtocol(body, ({success, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        
        if(success){
          this.loadDocuments();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
          this.emailDialogVisible = false;
        } else{
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })      
    },
    sendEmail5253() {
      if(this.selectedReport === "52-Consegna bolletta export"){
        this.$store.dispatch("generic/setLoading", true);
        
        Service.sendEmailReport52({idDocument: this.lastLoaded, idList: [this.lastLoaded, ...(this.documentsSorted.filter((document) => document.check).map((item) => item.id))]}, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          
          if(success){
          this.loadDocuments();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
            this.emailDialogVisible5253 = false;
          } else{
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
          
      }else if(this.selectedReport === "53-Trasmissione documenti amministrativi"){
        this.$store.dispatch("generic/setLoading", true);
    
        Service.sendEmailReport53({idDocument: this.lastLoaded, idList: [this.lastLoaded, ...(this.documentsSorted.filter((document) => document.check).map((item) => item.id))]}, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          
          if(success){
          this.loadDocuments();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
            this.emailDialogVisible5253 = false;
          } else{
            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })  
          
      }
    },

    onDocumentTypeSelected({value}){
      this.categoryOptions = this.allOptions[value];
    },
    onCategorySelected({value}){
      if(!this.newDocument.description) {
        this.newDocument.description = value;
      }
    },
    deleteDocument(item){
      this.$confirm.require({
          message: this.$t('messages.delete_message_question'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {
            let docData = {
              idVesselProtocol: this.vesselProtocolId,
              documentGuid: item.documentGuid
            };

            Service.deleteAttachmentVesselProtocolDocumentManager(docData, ({success, message}) => {
              if(success){
                this.loadDocuments();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            })
          },
          reject: () => {
              this.$confirm.close();
          }
      });
    },
    onRemoveTemplatingFile(file, removeFileCallback, index) {
        removeFileCallback(index);
        this.totalSize -= parseInt(this.formatSize(file.size));
        this.totalSizePercent = this.totalSize / 10;
    },
    onClearTemplatingUpload(clear) {
        clear();
        this.totalSize = 0;
        this.totalSizePercent = 0;
    },
    onSelectedFiles(event) {
        this.files = event.files;
        this.files.forEach((file) => {
            this.totalSize += parseInt(this.formatSize(file.size));
        });
    },
    uploadEvent(callback) {
        this.totalSizePercent = this.totalSize / 10;
        callback();
    },
    onTemplatedUpload() {
        this.$toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
    },
    formatSize(bytes) {
        if (bytes === 0) {
            return '0 B';
        }

        let k = 1000,
            dm = 3,
            sizes = ['Byte', 'KiloByte', 'MegaByte', 'GigaByte', 'TeraByte', 'PetaByte', 'EByte', 'ZByte', 'YByte'],
            i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    uploaderResponseMethod(file){
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
      });
      file.files.forEach( async (document) => {
        const base64 = await toBase64(document);

        let section =  this.newDocument.type == 'Tracking Discariche' ? 'DischargeTracking' :  this.newDocument.type;

        let formData = {
          idVesselProtocol: this.vesselProtocolId,
          section: section,
          description: this.newDocument.description,
          documentType: this.newDocument.category,
          fileNameWithExtension: document.name,
          fileContentBase64: base64,
        }
        this.$store.dispatch("generic/setLoading", true);
  
        this.lastLoaded = null;
        Service.addDocumentVesselProtocolDocumentManager(formData, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          this.newDocument.type = '';
          this.newDocument.category = '';
          this.newDocument.description = '';
          if(success){
            this.lastLoaded = data.guiIdDocument;
            if (data.openPopUp) {
              this.emailDialogVisible = true;
            }
            this.$toast.add({detail: this.$t('messages.upload_message_success'), life:3000, severity:'success'});
            this.loadDocuments();
          }else{
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      })
      this.loadDocuments();
    },
    toggleAddress(event){
      this.$refs.op.toggle(event)
    },
    showAddress(id){
      let params = {
        idDocument : id,
        idVesselProtocol: this.vesselProtocolId
      }

      this.mailAddresses = {value: "", escape: true};
      Service.getReportDataAddress(params, response => {
        if(response.success){
      this.mailAddresses.value = "<div style='width: 300px'>";

          let to = response.data.to;
          if(to && to.length > 0){
            this.mailAddresses.value += "TO: ";
            for(let i = 0; i<to.length; i++){
              this.mailAddresses.value += '<br> - ' + to[i];
            }
          }
          let cc = response.data.cc;
          if(cc && cc.length > 0){
            this.mailAddresses.value += "<br>CC: ";
            for(let i = 0; i<cc.length; i++){
              this.mailAddresses.value += '<br> - ' + cc[i];
            }
          }
          let ccn = response.data.bcc;
          if(ccn && ccn.length > 0){
            this.mailAddresses.value += "<br>CCN: ";
            for(let i = 0; i<ccn.length; i++){
              this.mailAddresses.value += '<br> - ' + ccn[i];
            }
          }
            this.mailAddresses.value += "</div>";
        }
      })
    },
    createDischargeTrackingMap(){
      this.dischargeTrackingRecordMap = {};

      this.dischargeTrackingRecordMap['Certificato di origine'] = this.dischargeTrackingRecord.certificateOfOriginStatus;
      this.dischargeTrackingRecordMap['Dichiarazione del fornitore'] = this.dischargeTrackingRecord.suppliersDeclarationStatus;
      this.dischargeTrackingRecordMap['Dichiarazione di esportazione'] = this.dischargeTrackingRecord.exportDeclarationStatus;
      this.dischargeTrackingRecordMap['Dichiarazione di non manipolazione'] = this.dischargeTrackingRecord.nonManipulationDeclarationStatus;
      this.dischargeTrackingRecordMap['Voyage Report'] = this.dischargeTrackingRecord.voyageReportStatus;
      this.dischargeTrackingRecordMap['Ricevuta documenti e campioni'] = this.dischargeTrackingRecord.receiptOfDocumentsAndSamplesStatus;
      this.dischargeTrackingRecordMap['Letter Of Protest (Samples)'] = this.dischargeTrackingRecord.letterOfProtestSamplesStatus;
      this.dischargeTrackingRecordMap['Letter Of Protest From Master'] = this.dischargeTrackingRecord.letterOfProtestFromMasterStatus;
    },
    saveDischargeTrackingStatus(item){
      this.$confirm.require({
          message: this.$t('DischargeTrackingReport.changeStatusMessage'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: this.$t('yes'),
          rejectLabel: this.$t('no'),
          accept: () => {
            let body = {
              id: this.dischargeTrackingRecord.id,
              documentType: item.documentType,
              documentStatus: this.dischargeTrackingRecordMap[item.documentType]
            };

            CommonService.updateItem('vessel-protocol-discharge-tracking-doc-status', body, response => {
              if(response.success){
                this.loadDischargeTrackingRecord()
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
              }else{
                this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
              }
            });
          },
          reject: () => {
              //callback to execute when user rejects the action
              this.createDischargeTrackingMap();
              this.$confirm.close();
          }
      });
    },
    formatFileName(document){
      let name = document.fileName + document.fileExtension;
      if(document.description){
        name += ' - ' +document.description;
      }
      return name;
    }
  },

    

}

</script>

<template>
  <main>
    <Dialog v-model:visible="dischargeTrackingStatusDialogVisible" modal :header="$t('DischargeTrackingReport.page_title')">
      <Dropdown v-model="currentStatus" :options="genericStatuses" optionLabel="label" optionValue="value" class="w-full md:w-14rem">
        <template #value="slotProps">
          <div class="flex align-items-center">
              <div>{{ $t('DischargeTrackingReport.status.' + slotProps.value) }}</div>
          </div>
        </template>
        <template #option="slotProps">
          <div class="flex align-items-center">
              <div>{{ $t('DischargeTrackingReport.status.' + slotProps.option.label) }}</div>
          </div>
        </template>
      </Dropdown>
      <ResponsiveButton icon="pi pi-save" v-tooltip="$t('btn.save')" class="p-button-rounded p-button-outlined" @click="saveDischargeTrackingStatus()" />
    </Dialog>
    <Dialog :header="'Report ' + selectedReport + ' - Email'" v-model:visible="emailDialogVisible5253" modal closable :style="{width: '60vw'}" >
      <template #header>
          <h3>
            {{'Report ' + selectedReport + ' - Email'}}
            <Button icon="pi pi-info" severity="success" text raised rounded @click="toggleAddress" />
          </h3>
          
          <OverlayPanel ref="op">
              <div v-html="mailAddresses.value" />
            </OverlayPanel>
        </template>
      <div class="grid">
        <div class="field col-12">
          <hr :style="{marginTop: '0'}">
          <p>{{ this.$t('vesselProtocol.isValueRevisionConfirm') }}</p>
          <p>{{ this.$t('vesselProtocol.proceedToSend') }}</p>
          <hr :style="{marginBottom: '0'}">
        </div>
        <div class="field col-12">
          <b>{{ this.$t('vesselProtocol.documentsToAttach') }}</b>
          <template v-for="document in documentsSorted" :key="document.id">
            <p>
              <Checkbox
                v-model="document.check" 
                :binary="true" />
              <label class="ml-2">{{ formatFileName(document) }}</label>
            </p>
          </template>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" class="p-button-outlined" @click="sendEmail5253" />
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-danger p-button-outlined" @click="emailDialogVisible5253 = false" />
      </template>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.customsBillEmail')" v-model:visible="emailDialogVisible" modal closable :style="{width: '60vw'}" >
       <template #header>
          <h3>{{$t('vesselProtocol.customsBillEmail')}}</h3>
          <Button icon="pi pi-info" severity="success" text raised rounded @click="toggleAddress" />
          <OverlayPanel ref="op">
              <div v-html="mailAddresses.value" />
            </OverlayPanel>
        </template>
      <div class="grid">
        <div class="field col-12">
          <hr :style="{marginTop: '0'}">
          <p>{{ this.$t('vesselProtocol.customsBillEmailInformation') }}</p>
          <p>{{ this.$t('vesselProtocol.proceedToSend') }}</p>
          <hr :style="{marginBottom: '0'}">
        </div>
        <div class="field col-12">
          <b>{{ this.$t('vesselProtocol.documentsToAttach') }}</b>
          <template v-for="document in data" :key="document.id">
            <p>
              <Checkbox
                v-model="document.check" 
                :binary="true" />
              <label class="ml-2">{{ document.documentType }}</label>
            </p>
          </template>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('vesselProtocol.sendNow')" icon="pi pi-check" class="p-button-outlined" @click="sendEmail" />
        <ResponsiveButton :label="$t('vesselProtocol.sendLater')" icon="pi pi-times" class="p-button-danger p-button-outlined" @click="emailDialogVisible = false" />
      </template>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <label for="uploaded[]">{{$t('vesselProtocol.document')}}</label>
        <FileUpload name="uploaded[]" customUpload @uploader="uploaderResponseMethod" :fileLimit="10" :previewWidth="0" :multiple="true" :disabled="!uiPermissions('vesselProtocolDocumentSaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolDocumentSaveButton').isHidden">
          <template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
            <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
              <div class="flex">
                <ResponsiveButton :label="$t('btn.selectDocuments')" icon="pi pi-file" class="p-button-outlined m-1" @click="chooseCallback()" />
                <ResponsiveButton :label="$t('btn.send')" icon="pi pi-cloud-upload" class="p-button-outlined m-1 p-button-success" @click="uploadEvent(uploadCallback)" severity="success" :disabled="!files || files.length === 0"/>
              </div>
              <div class="flex">
                <ResponsiveButton :label="$t('btn.cancelDocuments')" icon="pi pi-times" class="p-button-outlined m-1 p-button-danger ms-auto" @click="clearCallback()" severity="danger" :disabled="!files || files.length === 0" />
              </div>
            </div>
          </template>
          <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
            <div v-if="files.length > 0">
              <h5>{{$t('readyToSend')}}</h5>
              <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                  <span class="font-semibold">{{ file.name }}</span>
                  <div>{{ formatSize(file.size) }}</div>
                  <Badge :value="$t('readyToSend')" severity="warning" class="mt-2" />
                  <Button icon="pi pi-times" class="mt-2 p-button-danger" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded  severity="danger" />
                </div>
              </div>
            </div>
            <div v-if="uploadedFiles.length > 0">
              <h5>{{$t('Imported')}}</h5>
              <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                  <div>
                    <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" class="shadow-2" />
                  </div>
                  <span class="font-semibold">{{ file.name }}</span>
                  <div>{{ formatSize(file.size) }}</div>
                  <Badge :value="$t('Imported')" class="mt-3" severity="success" />
                  <Button icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined rounded  severity="danger" />
                </div>
              </div>
            </div>
          </template>
          <template #empty>
            <div class="flex align-items-center justify-content-center flex-column">
              <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
              <p class="mt-4 mb-0">{{ $t('vesselProtocol.dragAndDropFile')}}</p>
            </div>
          </template>
        </FileUpload>
      </div>
      <div class="col-6">
        <label for="type">{{$t('vesselProtocol.type')}}</label>
        <Dropdown
          name="type"
          class="w-full"
          :options="typeOptions"
          @change="onDocumentTypeSelected"
          v-model="newDocument.type" />
      </div>
      <div class="col-6">
        <label for="category">{{$t('vesselProtocol.category')}}</label>
        <Dropdown
          name="category"
          class="w-full"
          :options="categoryOptions"
          @change="onCategorySelected"
          v-model="newDocument.category" />
      </div>
      <div class="col-12">
        <label for="description">{{$t('description')}}</label>
        <Textarea name="description" v-model="newDocument.description" class="w-full" rows="5"/>
      </div>
      <div class="col-12">
        <DataTable :value="data" sortField="documentDate" :sortOrder="-1">
          <Column>
            <template #body="slotProps">
              <ResponsiveButton icon="pi pi-download" v-tooltip="$t('btn.download')" class="p-button-rounded p-button-outlined" @click="downloadDocument(slotProps.data)" v-if="slotProps.data.documentGuid" />
              <ResponsiveButton icon="pi pi-external-link" v-tooltip="$t('btn.viewFile')" class="p-button-rounded p-button-outlined" @click="openDocument(slotProps.data.documentUrl)" v-else />
            </template>
          </Column>
          <Column field="fileName" :header="$t('vesselProtocol.fileName')" :sortable="true" />
          <Column field="documentType" :header="$t('vesselProtocol.documentType')" :sortable="true" />
          <Column field="description" :header="$t('vesselProtocol.description')" :sortable="true" />
          <Column field="fileExtension" :header="$t('vesselProtocol.extension')" :sortable="true">
            <template #body="element">
              {{ element.data.fileExtension ? element.data.fileExtension.split('.').at(-1).toUpperCase() : "" }}
            </template>
          </Column>
          <Column field="customer" :header="$t('vesselProtocol.customer')" :sortable="true" />
          <Column field="createdBy" :header="$t('vesselProtocol.createdBy')" :sortable="true"  />
          <Column field="documentDate" :header="$t('documentDate')" :sortable="true">
            <template #body="element">
              {{element.data.documentDate ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.documentDate)) : null}}
            </template>
          </Column>
          <Column field="emailState" :header="$t('vesselProtocol.emailStatus')" :sortable="true">
            <template #body="element">
              <div class="flex justify-content-center" v-if="element.data.showMailButton" >
                {{ element.data.isMailSend ? $t('vesselProtocol.emailSent') : $t('vesselProtocol.emailNotSent')}}
              </div>
            </template>
          </Column>
          <Column field="sendEmail" :header="$t('vesselProtocol.sendEmail')" :sortable="true">
            <template #body="element">
              <div class="flex justify-content-center" v-if="element.data.showMailButton">
                <ResponsiveButton :icon="element.data.isMailSend ? 'pi pi-sync' : 'pi pi-send'" class="p-button-rounded p-button-outlined" :class="element.data.isMailSend ? 'p-button-success' : 'p-button-warning'" v-tooltip="element.data.isMailSend ? $t('vesselProtocol.resendEmail') : $t('vesselProtocol.sendEmail')" @click="openSendEmail(element.data)" :disabled="!uiPermissions('vesselProtocolDocumentSaveButton').isEnabled || isDisabled" />
              </div>
            </template>
          </Column>
          <Column :header="$t('DischargeTrackingReport.genericGridDocumentStatus')">
            <template #body="element">
              <span v-if="element.data.section == 'DischargeTracking' && uiPermissions('vesselProtocolDocumentSaveButton').isEnabled">
                <Dropdown v-model="dischargeTrackingRecordMap[element.data.documentType]" :options="genericStatuses" optionLabel="label" optionValue="value" class="w-full md:w-14rem" @change="saveDischargeTrackingStatus(element.data)">
                  <template #value="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t('DischargeTrackingReport.status.' + slotProps.value) }}</div>
                    </div>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ $t('DischargeTrackingReport.status.' + slotProps.option.label) }}</div>
                    </div>
                </template>
                </Dropdown>

              </span>
              <span v-else-if="element.data.section == 'DischargeTracking'">
                {{dischargeTrackingRecordMap[element.data.documentType] ? $t('DischargeTrackingReport.status.' + dischargeTrackingRecordMap[element.data.documentType]) : ''}}
              </span>
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <ResponsiveButton icon="pi pi-trash" v-tooltip="$t('btn.delete')" class="p-button-rounded p-button-outlined p-button-danger mr-2" @click="deleteDocument(slotProps.data)"
               :disabled="!uiPermissions('vesselProtocolDocumentSaveButton').isEnabled || isDisabled" v-if="slotProps.data.section != 'Attuazione'"/>
            </template>
          </Column>        </DataTable>
      </div>
    </div>
  </main>
</template>
